import { Progress, ProgressProps } from 'antd';
import React, { FC } from 'react';

export const ILSProgress: FC<ProgressProps> = (props) => {
  return <Progress {...props} />;
};
